import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import StoreLogo from '@prisjakt/ui-store-logo';
import { SHOP_LOGO_WIDTH } from 'src/areas/store/constants';
import { StoreRatingAverage } from '../store-rating-average';
import { trackShopLogoClick } from '../../tracking';
import { VARIANTS, StoreInfo, StoreInfoTitle } from './styles';

export const StoreInfoColumn: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { offer } = usePriceRowContext();
  const { store } = offer;

  if (!store) {
    return null;
  }

  const handleShopLogoClick = () => trackShopLogoClick(store.id);

  const highResolutionLogo = store.logo
    ? { url: store.logo, width: SHOP_LOGO_WIDTH }
    : null;
  return (
    <StoreInfo role="none" onClick={handleShopLogoClick}>
      <StoreInfoTitle>{store.name}</StoreInfoTitle>
      <StoreLogo
        name={store.name}
        storeId={store.id}
        featured={Boolean(store.featured)}
        hasImage={Boolean(store.hasLogo)}
        variant={VARIANTS.PRICE_LIST}
        logoUrl={highResolutionLogo?.url}
        width={highResolutionLogo?.width}
        showHighResolutionLogo={Boolean(highResolutionLogo)}
      />

      <StoreRatingAverage />
    </StoreInfo>
  );
};
